import React from 'react';
import image from '../../../Assets/Backgrounds/whatBanner.webp';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
const Banner=()=>{
    return(
        <>
        <SharedBanner 
        title="How To Run Your First Design Thinking Workshop Hub"
        backgroundImage={image}
        styles="noshade"
        />
        </>
    )
}
export default Banner ;

